import { useTranslation } from "react-i18next";
import { Avatar, Box, Divider, Typography } from "@mui/material";

import { Experience as ExperienceType } from "../../../../types/types";
import { formatMediaUrl } from "../../../../utils/formatters/formatMedia";

import { ExperienceIcon, PostsIcon } from "../../assets/icons/player-icons";

import { styles } from "./styles";

interface ExperienceItemProps {
  experience: ExperienceType;
}

export const ExperienceItem = ({
  experience: { team, startDate, endDate, playingLevel, role, matches, goals, postsCount },
}: ExperienceItemProps) => {
  const { t } = useTranslation(["profiles", "common"], { keyPrefix: "experience" });
  const { t: tCommon } = useTranslation("common", { keyPrefix: "user.role" });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", rowGap: "8px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <Avatar src={formatMediaUrl(team?.media?.url)} sx={{ width: "40px", height: "40px" }}>
          {team?.name?.slice(0, 2)}
        </Avatar>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography sx={styles.teamName}>{team?.name}</Typography>
          <Typography sx={styles.dateRange}>
            {startDate} - {endDate}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: "24px" }}>
        <Box sx={{ paddingLeft: "16px" }}>
          <ExperienceIcon />
        </Box>
        <Box sx={{ display: "flex", gap: "24px", paddingTop: "20px" }}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography sx={styles.teamName}>{tCommon(role)}</Typography>
            <Typography sx={styles.dateRange}>{playingLevel}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "24px", height: "fit-content" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
              <Typography sx={styles.statsLabel}>{t("matches")}:</Typography>
              <Typography sx={styles.statsValue}>{matches || "0"}</Typography>
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
              <Typography sx={styles.statsLabel}>{t("goals")}:</Typography>
              <Typography sx={styles.statsValue}>{goals || "0"}</Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "2px", height: "fit-content" }}>
            <PostsIcon />
            <Typography sx={styles.statsValue}>{postsCount}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
